<template>
  <div class="topUp" @click="click">
    <div class="top">
      <p>{{ lang('充值') }}</p>
      <div class="status" :style="status(props.data.verifyStatus).boxStyle">
        <p>{{ status(props.data.verifyStatus).name }}</p>
      </div>
    </div>
    <div class="bottom">
      <p class="time">{{ props.data.createTime }}</p>
      <div class="cost">
        <img src="../../../../assets/images/score/blackBase.png" />
        <p>{{ props.data.applyAmount }}</p>
        <img src="../../../../assets/images/score/more.png" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { chargeRecordsResp } from '@/model/score/score'
import lang from '@/langs'

const props = defineProps<{ data: chargeRecordsResp }>()
const emits = defineEmits(['click'])
const click = () => {
  emits('click')
}
const status = (type: number) => {
  if (type === 1) {
    return {
      name: lang('审核中'),
      boxStyle: {
        background: 'rgba(245, 125, 88, 0.1)',
        color: 'rgba(245, 125, 88, 1)'
      }
    }
  } else if (type === 2) {
    return {
      name: lang('成功'),
      boxStyle: {
        background: 'rgba(57, 174, 133, 0.1)',
        color: 'rgba(57, 174, 133, 1)'
      }
    }
  } else if (type === 3) {
    return {
      name: lang('失败'),
      boxStyle: {
        background: 'rgba(246, 246, 246, 1)',
        color: 'rgba(153, 153, 153, 1)'
      }
    }
  } else {
    return {
      name: lang('审核中'),
      boxStyle: {
        background: 'rgba(245, 125, 88, 0.1)',
        color: 'rgba(245, 125, 88, 1)'
      }
    }
  }
}
</script>

<style scoped lang="less">
.topUp {
  display: flex;
  flex-direction: column;
  background: #fff;
  margin: 0 10px;
  padding: 14px 11px;
  .top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 10px;
    > p {
      font-size: 12px;
    }
    .status {
      border-radius: 3px;
      padding: 3px 4px;
      font-size: 12px;
    }
  }
  .bottom {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .time {
      color: rgba(153, 153, 153, 1);
      font-size: 12px;
    }
    .cost {
      display: flex;
      flex-direction: row;
      align-items: center;
      color: rgba(60, 60, 60, 1);
      font-size: 12px;
      > img {
        width: 12px;
        height: 12px;
      }
      > p {
        margin: 0 4px;
      }
    }
  }
}
</style>
